'use es6';

import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { get } from 'share-with-third-party-component-lib/utils/ConnectionStatusErrorMessageGetter';
import { getSettingsPageUrl } from 'share-with-third-party-component-lib/utils/Url';
import { ReportActionsFloatingAlertStore } from 'reporting-action-components/shared/ReportActionsFloatingAlertStore';
import { Link } from 'foundations-components/transitional/components/Link';
import { showSuccessNotification } from '../shared/reportActionAlerts';
import { SHARE_EMAIL, SHARE_SLACK_APP_ID_NAME } from './shareTypes';
import { jsx as _jsx } from "react/jsx-runtime";
export const getDialogText = currentDialog => currentDialog === SHARE_EMAIL ? 'e-mail' : 'message';
export const sendNowSuccessMessage = currentDialog => {
  return currentDialog === SHARE_EMAIL ? showSuccessNotification({
    message: 'reporting-action-components.actions.emailReport.dialog.alert.emailNowSuccess'
  }) : showSuccessNotification({
    message: 'reporting-action-components.actions.slackReport.dialog.alert.sendSlackNowSuccess'
  });
};
export const showConnectionStatusWarningNotification = thirdPartyApp => {
  ReportActionsFloatingAlertStore.addAlert({
    type: 'warning',
    message: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: get(thirdPartyApp.integrationStatus),
      elements: {
        Link
      },
      options: {
        href: getSettingsPageUrl(),
        external: true,
        use: 'on-bright',
        appname: SHARE_SLACK_APP_ID_NAME
      }
    }),
    sticky: true
  });
};